import { render, staticRenderFns } from "./SubmitOrder.vue?vue&type=template&id=c9103c5a&scoped=true&"
import script from "./SubmitOrder.vue?vue&type=script&lang=js&"
export * from "./SubmitOrder.vue?vue&type=script&lang=js&"
import style0 from "./SubmitOrder.vue?vue&type=style&index=0&id=c9103c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9103c5a",
  null
  
)

export default component.exports